import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/ui/text/Text';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { LocalIcon } from '@/components/ui/images/LocalIcon';
import type { LocalIconName } from '@/components/ui/images/LocalIcon';

import { ROUTE_DEFINITIONS } from '@/routes';


interface EmptyPageProps {
  imageName: LocalIconName;
  title: string;
  subtitle: string;
}

export const EmptyPage: React.FC<EmptyPageProps> = ({ imageName, title, subtitle }) => {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full gap-6 py-16">
      <LocalIcon name={imageName} className="w-64 h-auto" />
      <Text variant="body-title-medium" textAlign="center">{title}</Text>
      <Text variant="body-regular" textAlign="center">{subtitle}</Text>
      <div className="flex gap-6 justify-center">
        <PrimaryButton variant="outline" onClick={() => globalThis.history.back()}>
          {translate('common:httpStatus.actions.goBack')}
        </PrimaryButton>
        <PrimaryButton onClick={() => navigate(ROUTE_DEFINITIONS.DASHBOARD_ASISTENCIA.path)}>
          {translate('common:httpStatus.actions.backToHome')}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default EmptyPage;
